export { default as de_DE } from '../assets/flags/de.svg';
export { default as en_US } from '../assets/flags/en.svg';
export { default as fr_FR } from '../assets/flags/fr.svg';
export { default as nl_NL } from '../assets/flags/nl.svg';
